import { Component, OnInit, Inject, Input, ViewChild, OnChanges, forwardRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgxCroppieComponent } from 'ngx-croppie';
import { CroppieOptions } from 'croppie';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-photo-crop-dialog',
  templateUrl: './photo-crop-dialog.component.html',
  styleUrls: ['./photo-crop-dialog.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhotoCropDialogComponent),
      multi: true
    }
  ]
})
export class PhotoCropDialogComponent implements OnInit, OnChanges, ControlValueAccessor {

  /* Pass the height of the image to this component */
  public imgCropToHeight = '280';

  /* Pass the width of the image to this component */
  public imgCropToWidth = '280';

  /* Our cropped image and the value of our image controller */
  public croppieImage;

  /* Options for the cropped image type and size */
  public outputoption = { type: 'base64', size: { width: 500, height: 500 } };

  /* Element to paint our form control */
  @ViewChild('ngxCroppie')
  ngxCroppie: NgxCroppieComponent;

  constructor(public dialogRef: MatDialogRef<PhotoCropDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.croppieImage = this.data.image;
  }


  ngOnChanges(changes: any) {
    if (this.croppieImage) {
      return;
    }

    if (!changes.imageUrl) {
      return;
    }
    if (!changes.imageUrl.previousValue && changes.imageUrl.currentValue) {
      this.croppieImage = changes.imageUrl.currentValue;
      this.propagateChange(this.croppieImage);
    }
  }

  public get croppieOptions(): CroppieOptions {
    const opts: CroppieOptions = {};
    opts.viewport = {
      width: parseInt(this.imgCropToWidth, 10),
      height: parseInt(this.imgCropToHeight, 10),
      type: 'circle'
    };
    opts.boundary = {
      width: parseInt(this.imgCropToWidth, 10) + 50,
      height: parseInt(this.imgCropToWidth, 10) + 50
    };

    opts.enforceBoundary = true;
    return opts;
  }



  newImageResultFromCroppie(img: string) {
    this.croppieImage = img;
    this.propagateChange(this.croppieImage);
  }

  confirm() {
    this.dialogRef.close(this.croppieImage);
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  /* Takes the value  */
  writeValue(value: any) {
    if (value !== undefined) {
      this.croppieImage = value;
      this.propagateChange(this.croppieImage);
    }
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}


}



// WEBPACK FOOTER //
// ./src/app/profile/component/profile/photo-crop-dialog/photo-crop-dialog.component.ts